import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FAQApi } from "../../api/bot/FAQApi";
import { initFAQ } from "../../../../modules/reducers/chat/bot/FAQ";
import { setMessage } from "../../../../modules/reducers/chat/bot/qa";

const useFAQ = ({ search, closeModal }) => {
  const dispatch = useDispatch();
  const brandId = useSelector((state) => state.checkArsStatus.brandId);

  const realtiemList = useSelector((state) => state.FAQ.realtiemList);
  const questionList = useSelector((state) => state.FAQ.questionList);

  const handleOnClick = (value, isHot, label) => {
    if (isHot) {
      const queryContent = {
        type: "USER",
        content: [
          {
            type: "text",
            value: label, // assuming label is "상품검색"
          },
        ],
      };
      dispatch(setMessage({ message: queryContent }));
      const parsedData = JSON.parse(value);
      const transformedData = {
        type: "REALTIME_ISSUE",
        content: [parsedData],
      };

      dispatch(setMessage({ message: transformedData }));
    } else {
      search({ message: value });
    }
    closeModal();
  };

  useEffect(() => {
    if (brandId !== "LD") {
      const api = FAQApi({ brandId });
      dispatch(initFAQ(api));
    }
  }, []);
  return { realtiemList, questionList, handleOnClick };
};

export default useFAQ;
